import { registerPlugin } from '@capacitor/core';
import { WebEventsPlugin } from '@/native/plugins/WebEvents/definitions';

const WebEvents = registerPlugin<WebEventsPlugin>('WebEvents', {
  web: () => import('./web').then((m) => new m.WebEvents()),
});

export * from './definitions';
export { WebEvents };
